export default {
    setPreOrders(state, preOrders) {
        state.preOrders = preOrders;
    },
    addPreOrder(state, preOrder) {
        state.preOrders = [...state.preOrders, preOrder];
    },
    setPreOrdersPerPage(state, perPage) {
        state.preOrdersPerPage = perPage;
    },
};
